"use client";

import { Checkbox } from "@/components/ui/Checkbox";
import { PATHS } from "@/consts";
import { useRichText } from "@/hooks/useRichText";
import { useTranslations } from "@/i18n/client";
import { Link } from "@/i18n/routing";
import { ChangeEvent } from "react";

export interface BackInStockCheckboxProps {
  checked: boolean;
  onChange: (_e: ChangeEvent<HTMLInputElement>) => void;
}

export const BackInStockCheckbox = ({
  checked,
  onChange,
}: BackInStockCheckboxProps) => {
  const t = useTranslations();
  const { rich } = useRichText();
  return (
    <Checkbox
      label={rich(t("backInStock.newsletter"), {
        link: chunks => (
          <Link key={1} href={PATHS.privacyPolicy}>
            {chunks}
          </Link>
        ),
      })}
      checked={checked}
      onChange={onChange}
    />
  );
};
